import AbsListItem from '../components/AbsListItem';

export default class ListItem extends AbsListItem{
    
    constructor(_name='', _store={}, _actions={}, _router={}, _el='', it = {}){
        super(_name, _store, _actions, _router, _el, it);

        this.favApi = `${this.store.getState().config.apiDomain}/webcontents/favorites/dolls/${it.id}`;
        this.detailPrefix = `magic-dolls_`;

        this.makeItem(it);
        this.addEvents();
    }

    makeItem(it = {}){
        const optionsA = it.buffBonusList.map( op => (op.displayValue? op.displayValue: '') );
        const options = optionsA.filter( op => op!=='' ).join(', ');

        this.itemEl = $(`
        <div class="tablerow${options?' has-option':''}" data-id="${it.id}">
            <div class="tablecell"><button class="btn-favorite${it.favorite?' is-active':''}" data-id="${it.id}">${it.favorite?'★':'☆'}</button></div>
            <div class="tablecell">
                <button class="btn-item">
                    <img class="thumb" src="${it.image}" onerror="this.src='${this.store.getState().defaultThumb}';">
                    <strong class="name" data-itemgrade="${it.gradeId}">${it.name}</strong>
                </button>
            </div>
            <div class="tablecell">${options || '-'}</div>
        </div>`);
        return this.itemEl;
    }

} // end of class